import type { JSX } from 'react';
import OpenXLogo from './assets/logo_color.svg?react';
import OpenXLogoWhite from './assets/logo_white.svg?react';
import type { LogoProps } from './utils/interfaces.ts';

export function Logo(props: Readonly<LogoProps>): JSX.Element {
  if (props.invertColors) {
    return <OpenXLogoWhite data-test={props['data-test']} style={{ zIndex: 1, height: '26px' }} />;
  }
  // z-index is necessary for the `deal-library` app to render the logo above the background icons
  return <OpenXLogo data-test={props['data-test']} style={{ zIndex: 1, height: '26px' }} />;
}
